import '../scss/app.scss';

console.log('Hello from custom theme!');